import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef, Injector, PLATFORM_ID, QueryList, Renderer2, ViewContainerRef } from '@angular/core';
import { TabPanel as TabPanelBase, TabView as TabViewBase } from 'prime-ng-old/tabview';
import { UiIconsModule } from '../icons';
import { UiTemplateDirective } from '../shared';
import { TimesIcon } from 'prime-ng-old/icons/times';
import { ChevronLeftIcon } from 'prime-ng-old/icons/chevronleft';
import { ChevronRightIcon } from 'prime-ng-old/icons/chevronright';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icons/icon.component";
const _c0 = ["*"];
function UiTabPanelComponent_Conditional_0_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTabPanelComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTabPanelComponent_Conditional_0_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate);
  }
}
function UiTabPanelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵprojection(1);
    i0.ɵɵconditionalCreate(2, UiTabPanelComponent_Conditional_0_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r0.selected);
    i0.ɵɵattribute("id", ctx_r0.tabView.getTabContentId(ctx_r0.id))("aria-hidden", !ctx_r0.selected)("aria-labelledby", ctx_r0.tabView.getTabHeaderActionId(ctx_r0.id))("data-pc-name", "tabpanel");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.contentTemplate && (ctx_r0.cache ? ctx_r0.loaded : ctx_r0.selected) ? 2 : -1);
  }
}
const _c1 = a0 => ({
  "p-tabview p-component": true,
  "p-tabview-scrollable": a0
});
const _c2 = (a0, a1) => ({
  "p-highlight": a0,
  "p-disabled": a1
});
function UiTabViewComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronLeftIcon");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function UiTabViewComponent_Conditional_3_3_ng_template_0_Template(rf, ctx) {}
function UiTabViewComponent_Conditional_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTabViewComponent_Conditional_3_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTabViewComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14, 4);
    i0.ɵɵlistener("click", function UiTabViewComponent_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navBackward());
    });
    i0.ɵɵconditionalCreate(2, UiTabViewComponent_Conditional_3_Conditional_2_Template, 1, 1, "ChevronLeftIcon");
    i0.ɵɵtemplate(3, UiTabViewComponent_Conditional_3_3_Template, 1, 0, null, 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("tabindex", ctx_r1.tabindex)("aria-label", ctx_r1.prevButtonAriaLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.previousIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.previousIconTemplate);
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 19);
  }
  if (rf & 2) {
    const tab_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", tab_r4.leftIcon);
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 21);
  }
  if (rf & 2) {
    const tab_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", tab_r4.rightIcon);
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabViewComponent_For_9_Conditional_0_Conditional_2_Conditional_0_Template, 1, 1, "ui-icon", 19);
    i0.ɵɵelementStart(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵconditionalCreate(4, UiTabViewComponent_For_9_Conditional_0_Conditional_2_Conditional_4_Template, 1, 1, "ui-icon", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵconditional(tab_r4.leftIcon ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tab_r4.header);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(tab_r4.rightIcon ? 4 : -1);
  }
}
function UiTabViewComponent_For_9_Conditional_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "TimesIcon", 24);
    i0.ɵɵlistener("click", function UiTabViewComponent_For_9_Conditional_0_Conditional_4_Conditional_0_Template_TimesIcon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const tab_r4 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close($event, tab_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-tabview-close");
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_4_2_ng_template_0_Template(rf, ctx) {}
function UiTabViewComponent_For_9_Conditional_0_Conditional_4_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTabViewComponent_For_9_Conditional_0_Conditional_4_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTabViewComponent_For_9_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabViewComponent_For_9_Conditional_0_Conditional_4_Conditional_0_Template, 1, 1, "TimesIcon", 22);
    i0.ɵɵconditionalCreate(1, UiTabViewComponent_For_9_Conditional_0_Conditional_4_Conditional_1_Template, 1, 0, "span", 23);
    i0.ɵɵtemplate(2, UiTabViewComponent_For_9_Conditional_0_Conditional_4_2_Template, 1, 0, null, 15);
  }
  if (rf & 2) {
    const tab_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵconditional(!tab_r4.closeIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(tab_r4.closeIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r4.closeIconTemplate);
  }
}
function UiTabViewComponent_For_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 17)(1, "a", 18);
    i0.ɵɵlistener("click", function UiTabViewComponent_For_9_Conditional_0_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const tab_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.open($event, tab_r4));
    })("keydown", function UiTabViewComponent_For_9_Conditional_0_Template_a_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const tab_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTabKeyDown($event, tab_r4));
    });
    i0.ɵɵconditionalCreate(2, UiTabViewComponent_For_9_Conditional_0_Conditional_2_Template, 5, 3);
    i0.ɵɵtemplate(3, UiTabViewComponent_For_9_Conditional_0_ng_container_3_Template, 1, 0, "ng-container", 15);
    i0.ɵɵconditionalCreate(4, UiTabViewComponent_For_9_Conditional_0_Conditional_4_Template, 3, 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const tab_r4 = ctx_r5.$implicit;
    const ɵ$index_19_r7 = ctx_r5.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(tab_r4.headerStyleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c2, tab_r4.selected, tab_r4.disabled))("ngStyle", tab_r4.headerStyle);
    i0.ɵɵattribute("data-p-disabled", tab_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", ctx_r1.getTabHeaderActionId(tab_r4.id))("aria-controls", ctx_r1.getTabContentId(tab_r4.id))("aria-selected", tab_r4.selected)("tabindex", tab_r4.disabled || !tab_r4.selected ? "-1" : ctx_r1.tabindex)("aria-disabled", tab_r4.disabled)("data-pc-index", ɵ$index_19_r7)("data-pc-section", "headeraction");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!tab_r4.headerTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r4.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(tab_r4.closable ? 4 : -1);
  }
}
function UiTabViewComponent_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabViewComponent_For_9_Conditional_0_Template, 5, 18, "li", 16);
  }
  if (rf & 2) {
    const tab_r4 = ctx.$implicit;
    i0.ɵɵconditional(!tab_r4.closed ? 0 : -1);
  }
}
function UiTabViewComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronRightIcon");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function UiTabViewComponent_Conditional_12_3_ng_template_0_Template(rf, ctx) {}
function UiTabViewComponent_Conditional_12_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTabViewComponent_Conditional_12_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTabViewComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25, 5);
    i0.ɵɵlistener("click", function UiTabViewComponent_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navForward());
    });
    i0.ɵɵconditionalCreate(2, UiTabViewComponent_Conditional_12_Conditional_2_Template, 1, 1, "ChevronRightIcon");
    i0.ɵɵtemplate(3, UiTabViewComponent_Conditional_12_3_Template, 1, 0, null, 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("tabindex", ctx_r1.tabindex)("aria-label", ctx_r1.nextButtonAriaLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.nextIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.nextIconTemplate);
  }
}
const _c3 = "@layer primeng{.p-tabview-nav-container{position:relative}.p-tabview-scrollable .p-tabview-nav-container{overflow:hidden}.p-tabview-nav-content{overflow-x:auto;overflow-y:hidden;scroll-behavior:smooth;scrollbar-width:none;overscroll-behavior:contain auto}.p-tabview-nav{display:inline-flex;min-width:100%;margin:0;padding:0;list-style-type:none;flex:1 1 auto}.p-tabview-nav-link{cursor:pointer;-webkit-user-select:none;user-select:none;display:flex;align-items:center;position:relative;text-decoration:none;overflow:hidden}.p-tabview-ink-bar{display:none;z-index:1}.p-tabview-nav-link:focus{z-index:1}.p-tabview-title{line-height:1;white-space:nowrap}.p-tabview-nav-btn{position:absolute;top:0;z-index:2;height:100%;display:flex;align-items:center;justify-content:center}.p-tabview-nav-prev{left:0}.p-tabview-nav-next{right:0}.p-tabview-nav-content::-webkit-scrollbar{display:none}.p-tabview-close{z-index:1}}ui-tabView{padding:0}.p-tabview .p-tabview-nav{background:var(--tabViewBarBgColor, transparent);border-bottom:var(--tabViewPanelSeparationBorderWidth) solid var(--tabViewBorderColor)}.p-tabview .p-tabview-nav li{margin-right:0}.p-tabview .p-tabview-nav li .p-tabview-nav-link{border:solid var(--tabViewBorderColor);border-width:0 0 var(--tabViewPanelSeparationBorderWidth) 0;border-color:transparent transparent var(--tabViewBorderColor) transparent;background:var(--tabViewBgColor);color:var(--tabViewTextColor);padding:0 1.25rem;height:60px;display:flex;justify-content:center;transition:box-shadow .2s;margin:0 0 calc(-1 * var(--tabViewPanelSeparationBorderWidth)) 0}.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus{border-bottom-color:var(--focusColor);color:var(--focusColor)}.p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link{background:var(--tabViewHoverBgColor);border-color:var(--tabViewHoverBorderColor);color:var(--tabViewHoverTextColor)}.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link{background:var(--tabViewActiveBgColor);border-color:var(--tabViewActiveBorderColor);font-weight:700;color:var(--tabViewActiveTextColor)}.p-tabview .p-tabview-left-icon{margin-right:.5rem}.p-tabview .p-tabview-right-icon,.p-tabview .p-tabview-close{margin-left:.5rem}.p-tabview .p-tabview-nav-btn.p-link{background:var(--tabViewBgColor);color:var(--primaryColor);width:3rem;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.p-tabview .p-tabview-nav-btn.p-link:focus{background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}.p-tabview .p-tabview-panels{background:var(--tabViewPanelColor);padding:1.25rem;border:0 none}.p-tabview.solid{--tabViewBgColor:var(--secondaryColor);--tabViewHoverBgColor:var(--primaryColor);--tabViewActiveBgColor:var(--primaryColor);--tabViewTextColor:var(--secondaryTextColor);--tabViewHoverTextColor:var(--primaryTextColor);--tabViewActiveTextColor:var(--primaryTextColor);--tabViewBorderColor: var(--inputBgColor);--tabViewHoverBorderColor: var(--primaryColor);--tabViewActiveBorderColor: var(--primaryColor)}.p-tabview.solid .p-tabview-nav{border-bottom-color:var(--tabViewActiveBgColor)}.p-tabview.solid .p-tabview-nav li .p-tabview-nav-link{border-width:0 1px var(--tabViewPanelSeparationBorderWidth) 0;border-color:transparent var(--tabViewBorderColor) var(--tabViewActiveBgColor) transparent}.p-tabview.nopadding .p-tabview-panels{padding:0}.p-tabview-stretched,.p-tabview-stretched .p-tabview,.p-tabview-stretched .p-tabview-panels,.p-tabview-stretched ui-tabPanel.active,.p-tabview-stretched ui-tabPanel.active .p-tabview-panel{flex:1;display:flex;flex-direction:column;justify-content:stretch;height:100%;overflow:hidden}.p-tabview-stretched .p-tabview-panels{height:auto}.p-tabview-stretched ui-tabPanel.active .p-tabview-panel{position:relative;overflow-y:auto}:host(.fill-height){flex:1;display:flex;flex-direction:column}:host(.fill-height) .p-tabview{flex:1;display:flex;flex-direction:column}:host(.fill-height) .p-tabview-panels{flex:1;display:flex;flex-direction:column;position:relative}:host(.fill-height) .p-tabview-panel:not([hidden]){position:absolute;inset:0;position:relative;overflow-y:auto}\n";
/**
 * in some situations Angular throws an ExpressionChangedAfterItHasBeenCheckedError.
 * It states some expression changed from true to false, trace mentions TabPanel_HostBindings , checkStylingProperty.
 * Tried to debug, without finding any clue on what is causing this.
 * ignored for now. Re-check when updating primeNg.
 */
export let UiTabPanelComponent = /*#__PURE__*/(() => {
  class UiTabPanelComponent extends TabPanelBase {
    get selected() {
      return this._selected;
    }
    set selected(val) {
      this._selected = val;
      if (val) this.loaded = true;
      // always detect changes
      this.cd.detectChanges();
    }
    constructor(injector, el, viewContainer, cd) {
      super(injector.get(UiTabViewComponent), el, viewContainer, cd);
      this.el = el;
      this.viewContainer = viewContainer;
      this.cd = cd;
      this.fillHeight = false;
      this._selected = false;
    }
    static {
      this.ɵfac = function UiTabPanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTabPanelComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTabPanelComponent,
        selectors: [["ui-tabPanel"]],
        contentQueries: function UiTabPanelComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        hostVars: 4,
        hostBindings: function UiTabPanelComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("fill-height", ctx.fillHeight)("active", ctx._selected);
          }
        },
        inputs: {
          name: "name",
          fillHeight: "fillHeight",
          selected: "selected",
          icon: "icon"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        consts: [["role", "tabpanel", 1, "p-tabview-panel", 3, "hidden"], [4, "ngTemplateOutlet"]],
        template: function UiTabPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵconditionalCreate(0, UiTabPanelComponent_Conditional_0_Template, 3, 6, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.closed ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgTemplateOutlet, UiIconsModule],
        styles: [_c3],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiTabPanelComponent;
})();
export let UiTabViewComponent = /*#__PURE__*/(() => {
  class UiTabViewComponent extends TabViewBase {
    constructor(platformId, el, cd, renderer) {
      super(platformId, el, cd, renderer);
      this.el = el;
      this.cd = cd;
      this.stretch = false;
    }
    // a useful helper method when controlling the tabs from outside, e.g. by url param
    findTabIndexByName(name) {
      name = name.toLowerCase();
      const selectedIndex = this.tabs.findIndex(tab => {
        // if no name has been specified, matching works against header string.
        const tabName = tab.name || tab.header;
        return tabName.toLowerCase() === name;
      });
      if (selectedIndex > -1) return selectedIndex;
      return null;
    }
    setActiveIndex(index) {
      // const tab = this.tabs[index]
      // this.open(null, tab)
      this.activeIndex = index;
      this.findSelectedTab().cd.markForCheck();
      this.tabChanged = true;
      this.cd.markForCheck();
      // this.cd.detectChanges();
    }
    static {
      this.ɵfac = function UiTabViewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTabViewComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTabViewComponent,
        selectors: [["ui-tabView"]],
        contentQueries: function UiTabViewComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiTabPanelComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabPanels = _t);
          }
        },
        hostVars: 2,
        hostBindings: function UiTabViewComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("p-tabview-stretched", ctx.stretch);
          }
        },
        inputs: {
          stretch: "stretch"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 15,
        vars: 12,
        consts: [["elementToObserve", ""], ["content", ""], ["navbar", ""], ["inkbar", ""], ["prevBtn", ""], ["nextBtn", ""], [3, "ngClass", "ngStyle"], [1, "p-tabview-nav-container"], ["type", "button", "pRipple", "", 1, "p-tabview-nav-prev", "p-tabview-nav-btn", "p-link"], [1, "p-tabview-nav-content", 3, "scroll"], ["role", "tablist", 1, "p-tabview-nav"], ["role", "presentation", "aria-hidden", "true", 1, "p-tabview-ink-bar"], ["type", "button", "pRipple", "", 1, "p-tabview-nav-next", "p-tabview-nav-btn", "p-link"], [1, "p-tabview-panels"], ["type", "button", "pRipple", "", 1, "p-tabview-nav-prev", "p-tabview-nav-btn", "p-link", 3, "click"], [4, "ngTemplateOutlet"], ["role", "presentation", 3, "ngClass", "ngStyle", "class"], ["role", "presentation", 3, "ngClass", "ngStyle"], ["role", "tab", "pRipple", "", 1, "p-tabview-nav-link", 3, "click", "keydown"], [1, "p-tabview-left-icon", 3, "icon"], [1, "p-tabview-title"], [1, "p-tabview-right-icon", 3, "icon"], [3, "styleClass"], [1, "tab.closeIconTemplate"], [3, "click", "styleClass"], ["type", "button", "pRipple", "", 1, "p-tabview-nav-next", "p-tabview-nav-btn", "p-link", 3, "click"]],
        template: function UiTabViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 6)(1, "div", 7, 0);
            i0.ɵɵconditionalCreate(3, UiTabViewComponent_Conditional_3_Template, 4, 4, "button", 8);
            i0.ɵɵelementStart(4, "div", 9, 1);
            i0.ɵɵlistener("scroll", function UiTabViewComponent_Template_div_scroll_4_listener($event) {
              return ctx.onScroll($event);
            });
            i0.ɵɵelementStart(6, "ul", 10, 2);
            i0.ɵɵrepeaterCreate(8, UiTabViewComponent_For_9_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelement(10, "li", 11, 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵconditionalCreate(12, UiTabViewComponent_Conditional_12_Template, 4, 4, "button", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 13);
            i0.ɵɵprojection(14);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx.scrollable))("ngStyle", ctx.style);
            i0.ɵɵattribute("data-pc-name", "tabview");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.scrollable && !ctx.backwardIsDisabled && ctx.autoHideButtons ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-pc-section", "navcontent");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("data-pc-section", "nav");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.tabs);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("data-pc-section", "inkbar");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.scrollable && !ctx.forwardIsDisabled && ctx.buttonVisible ? 12 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, UiIconsModule, i2.UiIconComponent, ChevronLeftIcon, ChevronRightIcon, TimesIcon],
        styles: [_c3],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiTabViewComponent;
})();
export const UiTabViewBundle = [UiTabPanelComponent, UiTabViewComponent];